import React from 'react';

import Icon from 'components/Icon';
import styles from './GraphEmptyState.scss';

/**
 * Empty State Component for the graph( technically a list of substories).
 * Shows up when there are no substories
 * @type {Object}
 */
const GraphEmptyState = ({ setDroppable }) => {
  return (
    <div
      className="graphview"
      onDragEnter={() => {
        setDroppable(true);
      }}
      onDragOver={(e) => {
        e.preventDefault();
      }}
      onDragLeave={(e) => {
        if (e.pageX === 0 && e.pageY === 0) return;
        setDroppable(false);
      }}
    />
  );
};
export default GraphEmptyState;
